module.exports = function() {
  return new Worker(__webpack_public_path__ + "e6a49aa5a21a9c1b8d3b.worker.js");
};